<template>
  <BoxAvatarTypeSharedInbox
    v-if="isSharedBox && isInboxBox"
    :box="box"
    :box-size="boxSize"
  />
  <BoxAvatarTypeShared
    v-else-if="isSharedBox"
    :avatar-size="size"
    :box="box"
    :box-size="boxSize"
    :icon-size="size - 16"
    :size="size - 10"
  />
  <BoxAvatarTypeInbox v-else-if="isInboxBox" :box="box" :box-size="boxSize" />
  <v-avatar v-else :size="size" tile>
    <BoxAvatarTypeIcon :box="box" :size="boxSize" />
  </v-avatar>
</template>

<script setup lang="ts">
import BoxAvatarTypeIcon from '@/components/box/BoxAvatarTypeIcon.vue'
import BoxAvatarTypeInbox from '@/components/box/BoxAvatarTypeInbox.vue'
import BoxAvatarTypeShared from '@/components/box/BoxAvatarTypeShared.vue'
import BoxAvatarTypeSharedInbox from '@/components/box/BoxAvatarTypeSharedInbox.vue'
import type { BoxEntry } from '@deepcloud/api-deep-box'

defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
  isSharedBox: {
    type: Boolean,
    default: false,
  },
  isInboxBox: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: 24,
  },
  boxSize: {
    type: Number,
    default: 24,
  },
})
</script>
